// Boilerplate local storage keys
export const LOCAL_STORAGE_KEY_LANGUAGE = 'boilerplate-language';
export const LOCAL_STORAGE_KEY_DARK_THEME_ENABLED =
  'boilerplate-darkThemeEnabled';
export const LOCAL_STORAGE_KEY_SCROLL_OFF_NAVBAR =
  'boilerplate-scrollOffNavbarEnabled';
